module.exports = __webpack_public_path__ + "static/media/blog.27a99f99.jpg";